<template>
  <div class="container my-4">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h1 class="h2 mb-3">Eliminar tu cuenta de Vida</h1>
        <p>
          Puedes eliminar tu cuenta y todos los datos asociados en cualquier momento, desde la app
          o desde la web:
        </p>
        <ol>
          <li>Inicia sesión en Vida.</li>
          <li>Ve a <strong>Perfil</strong> y baja hasta la sección <strong>Eliminar cuenta</strong>.</li>
          <li>Introduce tu contraseña y pulsa <strong>Eliminar mi cuenta definitivamente</strong>.</li>
        </ol>
        <p>
          <router-link v-if="autenticado" class="btn btn-outline-danger" to="/perfil">Ir a eliminar mi cuenta</router-link>
          <router-link v-else class="btn btn-primary" :to="{ path: '/login', query: { redirect: '/perfil' } }">Iniciar sesión</router-link>
        </p>

        <h2 class="h5 mt-4">Qué se elimina</h2>
        <p>
          Tu perfil, gastos, ingresos, suscripciones, datos de salud, tareas, listas, notas y las
          credenciales de las integraciones conectadas. El borrado es inmediato y definitivo.
          Si eras el creador de un grupo con más miembros, el grupo pasa a otro miembro.
        </p>

        <p>
          Si no puedes acceder a tu cuenta, solicita su eliminación escribiendo a
          <a href="mailto:visego@gmail.com">visego@gmail.com</a> desde el correo con el que te registraste.
        </p>

        <p class="small text-muted">
          Consulta la <router-link to="/privacidad">política de privacidad</router-link>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'EliminarCuentaInfo',
  setup() {
    const store = useStore();
    const autenticado = computed(() => !!store.getters['auth/isAuthenticated']);
    return { autenticado };
  }
};
</script>
